// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","329":"singleNew","443":"about","447":"singleItem","606":"singleSubCategory","631":"contact","876":"singleCategory"}[chunkId] || chunkId) + "." + {"177":"453bb40c","329":"c4347c92","435":"44b21363","443":"35b8fb22","447":"b2f6088f","606":"335ec6a9","631":"cf64f173","876":"726daa5a"}[chunkId] + ".js";
};